// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* var(--bs-table-bg); */

.MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled{
    background-color: var(--bs-table-bg) !important;
}

/* PDF Export Mode Styles */
.pdf-export-mode * {
    visibility: visible !important;
    opacity: 1 !important;
}

.pdf-export-mode .slick-list {
    overflow: visible !important;
    position: static !important;
}

.pdf-export-mode .slick-track {
    overflow: visible !important;
    display: flex !important;
    flex-wrap: wrap !important;
    position: static !important;
    gap: 10px !important;
    padding: 10px !important;
}

.pdf-export-mode .slick-slide {
    position: static !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    flex: 0 0 auto !important;
    width: 150px !important;
    min-height: 120px !important;
}

.pdf-export-mode .slick-prev,
.pdf-export-mode .slick-next {
    display: none !important;
}

.pdf-export-mode .slick-dots {
    display: none !important;
}

.pdf-export-mode img {
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/segments/audience-segments/AudienceSegments.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,+CAA+C;AACnD;;AAEA,2BAA2B;AAC3B;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;AAC7B","sourcesContent":["/* var(--bs-table-bg); */\n\n.MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled{\n    background-color: var(--bs-table-bg) !important;\n}\n\n/* PDF Export Mode Styles */\n.pdf-export-mode * {\n    visibility: visible !important;\n    opacity: 1 !important;\n}\n\n.pdf-export-mode .slick-list {\n    overflow: visible !important;\n    position: static !important;\n}\n\n.pdf-export-mode .slick-track {\n    overflow: visible !important;\n    display: flex !important;\n    flex-wrap: wrap !important;\n    position: static !important;\n    gap: 10px !important;\n    padding: 10px !important;\n}\n\n.pdf-export-mode .slick-slide {\n    position: static !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    display: block !important;\n    height: auto !important;\n    overflow: visible !important;\n    flex: 0 0 auto !important;\n    width: 150px !important;\n    min-height: 120px !important;\n}\n\n.pdf-export-mode .slick-prev,\n.pdf-export-mode .slick-next {\n    display: none !important;\n}\n\n.pdf-export-mode .slick-dots {\n    display: none !important;\n}\n\n.pdf-export-mode img {\n    visibility: visible !important;\n    opacity: 1 !important;\n    display: block !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
